const isValidHexColor = (color) => {
  const regex = /^#([0-9a-fA-F]{3}){1,2}$/;
  return !!color && regex.test(color);
};
export {
  isValidHexColor
};
